export default __webpack_public_path__ + "static/BgGame-f204438254fe56c8e4374fa8e6423945.webp";